import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { forwardRef } from "react";
import { useTheme } from "../../../../theme/utils/useTheme";
import { TypeRampV2 } from "../../../typography";
import { optionFontTheme } from "../selectV2Theme";
import { OptionBase } from "../shared/OptionBase";
import { MultiSelectCheckbox } from "./MultiSelectCheckbox";
export const MultiSelectOption = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    checkedState,
    ...props
  } = _ref;
  const {
    key
  } = useTheme();
  const themeMode = key;
  return /*#__PURE__*/React.createElement(OptionBase, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(MultiSelectCheckbox, {
    checkedState: checkedState,
    "aria-disabled": props.isDisabled
  }), /*#__PURE__*/React.createElement(TypeRampV2, {
    lineClamp: 1,
    variant: optionFontTheme.variant(themeMode),
    style: {
      color: "inherit"
    }
  }, children));
});
MultiSelectOption.displayName = "MultiSelectOption";
//# sourceMappingURL=MultiSelectOption.js.map